export default "assets/images/chateaux-logos/ricaud-955158b8.png";